import { render, staticRenderFns } from "./noticesHint.vue?vue&type=template&id=3085a6e2&scoped=true&"
import script from "./noticesHint.vue?vue&type=script&lang=js&"
export * from "./noticesHint.vue?vue&type=script&lang=js&"
import style0 from "./noticesHint.vue?vue&type=style&index=0&id=3085a6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3085a6e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3085a6e2')) {
      api.createRecord('3085a6e2', component.options)
    } else {
      api.reload('3085a6e2', component.options)
    }
    module.hot.accept("./noticesHint.vue?vue&type=template&id=3085a6e2&scoped=true&", function () {
      api.rerender('3085a6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/noticesHint.vue"
export default component.exports